export default {
    'gui.menuBar.seeProjectPage': 'プロジェクトページをみる',
    'gui.loader.creating': 'プロジェクトをさくせいちゅう...',
    'gui.smalruby3.crashMessage.description': 'もうしわけありません。スモウルビーがクラッシュしたようです。このバグはじどうてきにスモウルビーチームにほうこくされました。ページをさいよみこみしてください。',
    'gui.smalruby3.gui.defaultProjectTitle': 'スモウルビーのプロジェクト',
    'gui.smalruby3.gui.rubyTab': 'ルビー',
    'gui.smalruby3.previewInfo.betawelcome': 'スモウルビー3.0 ベータばんにようこそ!',
    'gui.smalruby3.previewInfo.label': 'スモウルビー3.0をためしてみる',
    'gui.smalruby3.previewInfo.invitation': 'わたしたちはじせだいのスモウルビーをかいはつちゅうです。おためしください!',
    'gui.smalruby3.previewInfo.welcome': 'スモウルビー3.0 プレビューばんにようこそ!',
    'gui.smalruby3.menuBar.downloadRubyCodeToComputer': 'コンピュータにルビーをほぞんする',
    'gui.smalruby3.unsupportedBrowser.description': 'もうしわけありません。スモウルビー3.0はインターネットエクスプローラ、ビヴァルディ、オペラ、シルクをサポートしていません。グーグル クローム、モジラ ファイアーフォックス、マイクロソフト エッジのようなあたらしいブラウザのりようをおすすめします。',
    'gui.smalruby3.webglModal.description': 'ざんねんながら、ブラウザーやコンピューターが{webGlLink}ようです。このぎじゅつはスモウルビー3.0のじっこうにひっすです。',
    'gui.smalruby3.alerts.convertRubyToBlocksError': 'ルビーからコードにへんかんできませんでした。ルビーをなおしてください！',
    'gui.smalruby3.telemetryOptIn.label': 'スモウルビーをかいぜんするためのりようじょうきょうのほうこく',
    'gui.smalruby3.telemetryOptIn.body1': 'スモウルビーのかいはつしゃはせかいじゅうでスモウルビーがどのようにつかわれているのかをりかいしたいとかんがえています。そのてだすけのために、みなさんのスモウルビーのりようじょうきょうをスモウルビーのかいはつしゃにていきょうしていただけないでしょうか。',
    'gui.smalruby3.telemetryOptIn.body2': 'ていきょうしていただくじょうほうにはどのげんごをせんたくしたか、どのブロックをつかったか、ほぞん・よみこみ・プロジェクトのアップロードなどのイベントをふくみます。ただし、ユーザめいなどのこじんてきなじょうほうはいっさいふくみません。',
    'gui.telemetryOptIn.buttonTextNo': 'いいえ、けっこうです。',
    'gui.smalruby3.telemetryOptIn.buttonTextYes': 'はい、スモウルビーのかいぜんにきょうりょくします。',
    'gui.smalruby3.rubyToBlocksConverter.couldNotConvertPremitive': '「{ SOURCE }」はブロックにへんかんできません。',
    'gui.smalruby3.rubyToBlocksConverter.wrongInstruction': '「{ SOURCE }」はめいれいがまちがっています。',
    'gui.smalruby3.extension.mesh.name': 'メッシュ',
    'gui.smalruby3.extension.mesh.description': 'ネットワークじょうでユーザーかんのやりとりをおこなう。',
    //
    'gui.kanirobo1.name': 'かにロボ1',
    'gui.kanirobo1.description': 'かにロボブロック (かんたん)',
    'gui.kanirobo1v2.name': 'かにロボ1v2',
    'gui.kanirobo1v2.description': 'かにロボブロック (かんたん v2)',
    'gui.kanirobo2.name': 'かにロボ2',
    'gui.kanirobo2.description': 'かにロボブロック (ふつう)',
    'gui.microcom.name': 'マイコン (はんよう)',
    'gui.microcom.description': 'マイコン (はんよう)．GPIO, PWM, ADC, I2C, UART',
    'gui.mboard1.name': 'MBoard1',
    'gui.mboard1.description': 'まつえこうせん マイコンボード (かんたん)．LED, スイッチ, ブザー, サーミスタおんどけい',
    'gui.mboard2.name': 'MBoard2',
    'gui.mboard2.description': 'まつえこうせん マイコンボード (ふつう)．LED, スイッチ, ブザー, サーミスタおんどけい',
    'gui.mboard3.name': 'MBoard3',
    'gui.mboard3.description': 'まつえこうせん マイコンボード (きょうつう)．えきしょうディスプレイなど',
    'gui.tools.name': 'Tools',
    'gui.tools.description': 'でばっぐつーる．ひょうじなど',
    'gui.m5stack.name': 'M5stack',
    'gui.m5stack.description': 'M5stack．ひょうじなど',
    'gui.sensor.name': 'センサー',
    'gui.sensor.description': 'センサーようブロック．SCD30, など',
    'gui.rboard.name': 'RBoard',
    'gui.rboard.description': 'RBoard (GPIO, PWM, ADC, ...)',
    // MBoard共通
    'mboard.sound_C': 'ド',
    'mboard.sound_D': 'レ',
    'mboard.sound_E': 'ミ',
    'mboard.sound_F': 'ファ',
    'mboard.sound_G': 'ソ',
    'mboard.sound_A': 'ラ',
    'mboard.sound_H': 'シ',
    'mboard.sound_hiC': 'ド',
    // MBoard1
    'mboard1.name': 'かんたん',
    'mboard1.led1': 'LED 1[NUM1] 2[NUM2] 3[NUM3] 4[NUM4] 5[NUM5] 6[NUM6] 7[NUM7] 8[NUM8]',
    'mboard1.switch1': 'スイッチ 1[SWITCH1] 2[SWITCH2] 3[SWITCH3] 4[SWITCH4]',
    'mboard1.sound1': '[SCALE] のおとをならす',
    'mboard1.sound2': 'おとをとめる',
    'mboard1.temperature1': 'サーミスタおんどけいのおんど',
    // MBoard2
    'mboard2.name': 'ふつう',
    'mboard2.led0': 'しょきか: [TEXT1]',
    'mboard2.led1': '[TEXT1] を [NUM1] にする',
    'mboard2.switch0': 'しょきか: [TEXT1]',
    'mboard2.switch1': '[TEXT1] が ON?',
    'mboard2.sound0': 'しょきか:ブザー',
    'mboard2.sound1': '[TEXT1] のおとをならす',
    'mboard2.sound2': 'おとをとめる',
    'mboard2.temperature0': 'しょきか: きばんじょうのサーミスタおんどけい',
    'mboard2.temperature2': 'おんどをはかる: サーミスタおんどけい',
    'mboard2.temperature1': 'サーミスタおんどけいのおんど',
    //
    'mboard3.name': 'きょうつう',
    'mboard3.monitor': 'モニターの[NUM]ぎょうめに[TEXT]とかく',
    'mboard3.date0': '年月日 時分秒',
    'mboard3.date1': '年-月-日',
    'mboard3.date2': '時:分:秒',
    'mboard3.date3': '年(4桁)',
    'mboard3.date4': '年(下2桁)',
    'mboard3.date5': '月',
    'mboard3.date6': '日',
    'mboard3.date7': '時',
    'mboard3.date8': '分',
    'mboard3.date9': '秒',
    'mboard3.lng': 'けいど',
    'mboard3.lat': 'いど',
    'mboard3.temp': 'おんど',
    'mboard3.humi': 'しつど',
    'mboard3.co2': 'CO2',
    'mboard3.tz_jst': 'にほんじかん',
    'mboard3.tz_utc': 'せかいひょうじゅんじ',
    'mboard3.wifi_init': 'Wi-Fi しょきか: SSID [SSID] パスフレーズ [PASS]',
    'mboard3.wifi_connected': 'Wi-Fi: せつぞくしている?',
    'mboard3.rtc_init': 'RTC しょきか',
    'mboard3.rtc_date': 'RTC : じこく [TEXT]',
    'mboard3.send': 'Wi-Fi データそうしん: おくりさき[TEXT1], なまえ[TEXT2], じこく[TEXT3], [VAR1] [TEXT4], [VAR2]',
    //
    'microcom.name': 'はんよう',
    'microcom.gpio_output_init': 'GPIO しゅつりょく: [NUM1]ピンをつかう',
    'microcom.gpio_output': 'GPIO しゅつりょく: [NUM1] ピンのあたいを [VALUE] にする',
    'microcom.gpio_input_init': 'GPIO にゅうりょく: [NUM1]ピンをつかう',
    'microcom.gpio_input': 'GPIO にゅうりょく: [NUM1] ピンのあたい',
    'microcom.pwm_init': 'PWM: [NUM1]ピンをつかう(タイマー[NUM2], チャンネル[NUM3], しゅうはすう:[NUM4])',
    'microcom.pwm_duty': 'PWM: [NUM1]ピンのデューティーひを [VALUE]% にする',
    'microcom.pwm_frequency': 'PWM: [NUM1]ピンのしゅうはすうを [VALUE] にする',
    'microcom.pwm_pulse': 'PWM: [NUM1]ピンのパルスはばを [VALUE] マイクロ秒にする',
    'microcom.adc_init': 'ADC: [NUM1]ピンをつかう',
    'microcom.adc_volt': 'ADC: [NUM1]ピンのあたい',
    'microcom.i2c_init': 'I2C: GPIO[NUM1] (SCL), GPIO[NUM2] (SDA) をつかう',
    'microcom.i2c_write': 'しゅつりょく I2C: あどれす 0x[NUM1], こまんど 0x[NUM2], あたい 0x[NUM3]',
    'microcom.i2c_read': 'にゅうりょく I2C: あどれす 0x[NUM1], ばいとすう [NUM2]',
    'microcom.uart_init': 'UART-[TEXT] をつかう. つうしんそくど [NUM]',
    'microcom.uart_write': 'しゅつりょく UART-[TEXT1]: [TEXT2]',
    'microcom.uart_read': 'にゅうりょく I2C-[TEXT]',
    //
    'kanirobo1.name': 'かにろぼ(ふつう)',
    'kanirobo1.Menu1.forward': 'まえ',
    'kanirobo1.Menu1.backward': 'うしろ',
    'kanirobo1.menu2.right': 'みぎ',
    'kanirobo1.menu2.left': 'ひだり',
    'kanirobo1.motor': 'もーたー[TEXT1]を[TEXT2]ほうこうにせっと. スピード[TEXT3]パーセント',
    'kanirobo1.value0': 'らいとせんさー[TEXT]のあたい',
    'kanirobo1.command9': 'さーぼもーたー[TEXT]を[NUM]どにする',
    //
    'kanirobo1v2.name': 'かにろぼ(ふつう)',
    'kanirobo1v2.Menu1.forward': 'まえ',
    'kanirobo1v2.Menu1.backward': 'うしろ',
    'kanirobo1v2.menu2.right': 'みぎ',
    'kanirobo1v2.menu2.left': 'ひだり',
    'kanirobo1v2.motor': 'もーたー[TEXT1]を[TEXT2]ほうこうにせっと. スピード[TEXT3]パーセント',
    'kanirobo1v2.value0': 'らいとせんさー[TEXT]のあたい',
    'kanirobo1v2.command9': 'さーぼもーたー[TEXT]を[NUM]どにする',
    //
    'kanirobo2.name': 'かにろぼ(ふつう)',
    'kanirobo2.Menu1.forward': '1',
    'kanirobo2.Menu1.backward': '2',
    'kanirobo2.Menu3.enable': 'ゆうこう',
    'kanirobo2.Menu3.disable': 'むこう',
    'kanirobo2.command0': 'もーたーゆうこうかぴんをしょきか',
    'kanirobo2.command1': 'もーたーゆうこうかぴんを[TEXT]か',
    'kanirobo2.command2': 'もーたー[TEXT]のGPIOをしょきか',
    'kanirobo2.command3': 'もーたー[TEXT]のPWMをしょきか',
    'kanirobo2.command4': 'もーたー[TEXT1]のGPIOを[TEXT2](1:まえ，0:うしろ)にせっと',
    'kanirobo2.command5': 'もーたー[TEXT]のPWMのでゅーてぃーひを[NUM]% にセット',
    'kanirobo2.command6': 'らいとせんさー[TEXT]をしょきか',
    'kanirobo2.value0': 'らいとせんさー[TEXT]のあたい',
    'kanirobo2.command7': 'さーぼもーたー[TEXT]をしょきか．しゅうき[NUM]ミリ秒',
    'kanirobo2.command8': 'さーぼもーたー[TEXT]のパルスはばを[NUM]ミリ秒にする',
    //
    'm5stack.line1': 'せん',
    'm5stack.line2': 'しかく',
    'm5stack.line3': 'しかく(わくのみ)',
    'm5stack.circle1': 'えん',
    'm5stack.circle2': 'えん(わくのみ)',
    'm5stack.white': 'しろ',
    'm5stack.black': 'くろ',
    'm5stack.red': 'あか',
    'm5stack.blue': 'あお',
    'm5stack.green': 'みどり',
    'm5stack.yellow': 'きいろ',
    'm5stack.m5lcd_write1': 'M5Stack モニター: いち([POS1], [POS2]) からいち([POS3], [POS4]) へ [TYPE] をかく (いろ [COLOR])',
    'm5stack.m5lcd_write2': 'M5Stack モニター: いち([POS1], [POS2]) をちゅうしんにはんけい [SIZE] の [TYPE] をかく (いろ [COLOR])',
    'm5stack.m5lcd_write3': 'M5Stack モニター: いち([POS1], [POS2]) からもじサイズ[SIZE] でもじれつ [MESS] をかく (いろ [COLOR])',
    //
    'sensor.temp': 'おんど',
    'sensor.humi': 'しつど',
    'sensor.co2': 'CO2',
    'sensor.scd30_status': 'SCD30 : データ しゅとくした？',
    'sensor.scd30': 'SCD30 [TYPE]',
    //
    'tools.name': 'デバッグ',
    'tools.puts': 'ひょうじ [TEXT]',
    // RBoard2
    'rboard.name': 'RBoard',
    'rboard.gpio_output_init': 'GPIO しゅつりょく: [NUM1] をつかう',
    'rboard.gpio_output': 'GPIO しゅつりょく: [NUM1] のあたいを [VALUE] にする',
    'rboard.gpio_input_init': 'GPIO にゅうりょく: [NUM1] をつかう',
    'rboard.gpio_input': 'GPIO にゅうりょく: [NUM1] のあたい',
    'rboard.pwm_init': 'PWM: [NUM1] をつかう',
    'rboard.pwm_duty': 'PWM: [NUM1] のデューティーひを [VALUE]% にする',
    'rboard.pwm_frequency': 'PWM: [NUM1] のしゅうはすうを [VALUE] にする',
    'rboard.adc_init': 'ADC: [NUM1] をつかう',
    'rboard.adc_volt': 'ADC: [VALUE] のあたい',
    'rboard.i2c_init': 'I2C をつかう',
    'rboard.i2c_write': 'I2C しゅつりょく: あどれす 0x[NUM1], こまんど 0x[NUM2], あたい 0x[NUM3]',
    'rboard.i2c_read': 'I2C にゅうりょく: あどれす 0x[NUM1], ばいとすう [NUM2], こまんど 0x[NUM3]',
    'rboard.uart_init': 'UART をつかう. つうしんそくど [NUM]',
    'rboard.uart_write': 'UART しゅつりょく: [TEXT2]',
    'rboard.uart_read': 'UART にゅうりょく',
    'rboard.puts': 'ひょうじ [TEXT]'
};
